import { CSSObject } from '@emotion/react'
import { DESKTOP, styles as sharedStyles } from '../../styles'

const getSlideStyles = (hasPhoto: boolean): CSSObject => ({
  ...sharedStyles.getSlideFrameStyles({
    width: DESKTOP.slideWidth,
    height: DESKTOP.height,
    hasPhoto,
  }),
  backgroundColor: 'black',
})

const picker = sharedStyles.getPickerStyles(DESKTOP.slideWidth, DESKTOP.height)

const styles = {
  getSlideStyles,
  picker,
}

export { styles }
